export function PurchasesPanel() {
  return (
    <section aria-labelledby="purchases-title" className="purchases-panel" id="purchases">
      <div className="workspace-heading">
        <div>
          <p className="eyebrow">Ecommerce</p>
          <h2 id="purchases-title">Purchases</h2>
        </div>
        <span>Personal</span>
      </div>
      <p className="empty-state">No ecommerce purchases have been recorded for this account.</p>
    </section>
  );
}
